// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"779":"7962c2083ebb8557","1649":"f7e7a5ea81d8a69f","4952":"4def6c0e99bc8f72"}[chunkId] + ".css";
};